import type { PropsWithChildren } from "react";

type SummaryRowProps = {
  title: string;
};

export const DataRow = ({ children, title }: SummaryRowProps & PropsWithChildren) => {
  return (
    <div className="flex border-b border-line px-4 py-5 text-sm break-words last:border-b-0">
      <div className="w-1/2 min-w-0 pr-4">
        <span className="font-medium text-content-muted">{title}</span>
      </div>

      <div className="w-1/2 min-w-0">
        <span className="text-content-strong">{children}</span>
      </div>
    </div>
  );
};
